import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getFormTemplates = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}form_templates`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getFormTemplates